import axios from "axios"; // 引入axios
import router from "../router";
import { Message } from "element-ui";
import store from "../store/index";
import { jcUrl } from "./url";
// process.env.VUE_APP_BASEURL
const service = axios.create({
  baseURL: jcUrl,
  timeout: 1800000
});
window._axiosPromiseArr = [];
service.interceptors.request.use(
  config => {
    if (config.url === "/manage/staff/login") {
      config.headers = {
        "Content-Type": "application/json",
        ...config.headers
      };
    } else {
      config.headers = {
        "Content-Type": "application/json",
        satoken: sessionStorage.getItem("token"),
        // lang:2222,
        ...config.headers
      };
    }
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel });
    });
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response 拦截器
service.interceptors.response.use(
  response => {
    // console.log(response)
    // 下载文件处理文件名
    if (response.headers["content-disposition"]) {
      response.data.fileName = decodeURIComponent(
        response.headers["content-disposition"].split("=")[1]
      );
    }
    // console.log(response.data,'------respond.data')
    if (response.data.status == "A0230") {
      alert("该账号已禁用，将被强制登出");
      router.replace({
        path: "/login"
      });
    }

    if (response.data.status == 0) {
      // console.log(response.data,'------respond.data')
      return response.data;
    } else {
      if (response.message) {
        alert(response.data.message);
      }

      return response.data;
    }
  },
  error => {
    switch (error.response && error.response.status) {
      case 500:
        if (error.response.data.status == "A0001") {
          // Message.error('该账号已被禁用')
          if (error.response.data.message == "此账号已被禁止访问服务：login") {
            Message.error("该账号已被禁用");
          } else {
            Message.error(error.response.data.message);
          }
        } else {
          Message.error("系统错误，请稍后再试");
        }
        // console.log(error.response)
        break;
      case 404:
        console.log("404");
        break;
    }
    store.state.isLoading = false;
    return Promise.reject(error);
  }
);
export default service;
